/* eslint-disable @typescript-eslint/no-use-before-define */
import { useContext, useEffect, useState } from "react";
import {
  compareEmbeddings,
  scanFrontDocument,
} from "@privateid/ultra-web-sdk-alpha";
import Rerun from "../utils/reRuncheck";
import { useToast } from "components/ui/use-toast";
import { useNavigateWithQueryParams } from "utils/navigateWithQueryParams";
import { UserContext } from "context/userContext";
import {
  getFrontDocumentStatusMessage,
} from "@privateid/ultra-web-sdk-alpha/dist/utils";

const useScanPassport = (
  onSuccess: ({
    croppedDocument,
    inputImage,
    croppedMugshot,
    portraitConfScore,
  }: {
    croppedDocument: string | null;
    inputImage: string | null;
    croppedMugshot: string | null;
    portraitConfScore: number;
  }) => void,
  onFailCallback: ({
    status,
    message,
  }: {
    status: string;
    message: string;
  }) => void,
  enrollEmbeddings: string,
  redirect?: string
) => {
  const context: any = useContext(UserContext);
  const { navigateWithQueryParams } = useNavigateWithQueryParams();
  const { toast } = useToast();
  const [isFound, setIsFound] = useState(false);
  const [resultStatus, setResultStatus] = useState(null);
  const [scanStatus, setScanStatus] = useState("");

  // base64 image
  const [croppedDocumentBase64, setCroppedDocumentBase64] = useState(null);
  const [croppedMugshotBase64, setCroppedMugshotBase64] = useState(null);

  const [documentEmbeddings, setDocumentEmbeddings] = useState(null);
  const [resultResponse, setResultResponse] = useState(null);
  const [returnValue, setResultValue] = useState<any>({});

  const documentCallback = (result: any) => {
    console.log("Front scan callback result:", result);
    RerunAction.RerunAction = false;
    setResultResponse(result);
    setResultStatus(result?.doc_validation_status);

    if (
      result?.doc_validation_status === 0 ||
      result?.doc_validation_status === 10
    ) {
      RerunAction.clearCheck();

      if (
        result?.cropped_document &&
        result?.cropped_mugshot &&
        result?.embedding
      ) {
        setIsFound(true);
        setCroppedMugshotBase64(result?.cropped_mugshot);
        setDocumentEmbeddings(result?.embedding);
        setCroppedDocumentBase64(result?.cropped_document);
        setResultValue(result);
        setScanStatus("");
      } else {
        doScanFrontDocument();
        setScanStatus("");
      }
    } else {
      onFailCallback({
        status: result?.doc_validation_status.toString(),
        message: getFrontDocumentStatusMessage(result?.doc_validation_status),
      });
      doScanFrontDocument();
    }
  };

  useEffect(() => {
    if (
      isFound &&
      croppedDocumentBase64 &&
      croppedMugshotBase64 &&
      documentEmbeddings
    ) {
      console.log("Comparing embeddings...", { documentEmbeddings, enrollEmbeddings });

      const compareCallback = async (result: any) => {
        console.log("Compare callback:", result);

        if (result?.call_status === 0) {
          onSuccess({
            croppedDocument: "data:image/png;base64," + croppedDocumentBase64,
            croppedMugshot: "data:image/png;base64," + croppedMugshotBase64,
            portraitConfScore: result?.confidence_score,
            inputImage: "",
          });
        } else {
          doScanFrontDocument();
        }
      };

      const doCompare = async () => {
        console.log("Starting comparison...", { documentEmbeddings, enrollEmbeddings });
        await compareEmbeddings(
          documentEmbeddings,
          enrollEmbeddings,
          {},
          compareCallback
        );
      };

      if (enrollEmbeddings) {
        doCompare();
      } else {
        toast({
          variant: "destructive",
          description: "Encrypted Embeddings not found. Please scan your face again.",
        });
        navigateWithQueryParams(redirect || "/face-scan-intro");
      }
    }
  }, [
    isFound,
    croppedDocumentBase64,
    croppedMugshotBase64,
    documentEmbeddings,
  ]);

  const doScanFrontDocument = async () => {
    await scanFrontDocument({
      callback: documentCallback,
      config: {
        input_image_format: "rgba",
        document_auto_rotation: true,
        detect_and_recognize_mrz_code: true,
      },
    });
  };

  const RerunAction = new Rerun(doScanFrontDocument);

  const reScanFrontDocument = () => {
    setCroppedDocumentBase64(null);
    setCroppedMugshotBase64(null);
    setResultValue({});
    doScanFrontDocument();
  };

  return {
    scanFrontDocument: doScanFrontDocument,
    isFound,
    setIsFound,
    resultStatus,
    resultResponse,
    reScanFrontDocument,
    scanStatus,
  };
};

export default useScanPassport;
